__turbopack_context__.v({
  "headerCollapsed": "HeaderCollapsed-module__JwDJiG__headerCollapsed",
});
